import { itemTypeEnum } from "@/enums/components/list";
import { computed, toRefs } from '@vue/reactivity';
export default {
  name: "groupCard",
  props: {
    groupInfo: {
      type: Object,
      required: true
    },
    position: {
      type: Number,
      required: true
    },
    langPath: {
      type: String,
      required: true
    },
    impressionHandler: {
      type: Function,
      required: false,
      default() {
        return () => true;
      }
    },
    clickCardHandler: {
      type: Function,
      required: false,
      default() {
        return () => true;
      }
    }
  },
  setup(props) {
    const {
      groupInfo,
      langPath
    } = toRefs(props);
    const instructorsThumbnailUrl = process.env.VUE_APP_INSTRUCTORS_THUMBNAIL_URL;
    const iconIdTable = {
      "iClone": "#ic7_none_border",
      "Character Creator": "#cc_none_border",
      "Cartoon Animator": "#cta_none_border"
    };
    const hasExternalLink = computed(() => groupInfo.value.type === itemTypeEnum.LINK && groupInfo.value.link.includes('://') && !groupInfo.value.link.includes(window.location.hostname));
    const isMagazine = link => link.includes('magazine.reallusion.com');
    if (groupInfo.value.type === itemTypeEnum.LINK && !hasExternalLink.value) {
      groupInfo.value.link = (langPath.value + groupInfo.value.link).replace(/\/{2,}/g, "/");
    }
    return {
      itemTypeEnum,
      instructorsThumbnailUrl,
      iconIdTable,
      hasExternalLink,
      isMagazine
    };
  }
};